import React, { useEffect } from "react";
import PropTypes from "prop-types";
import SectionToggle from "../../../../components/sectionToggle/sectionToggle";
import { useDispatch, useSelector } from "react-redux";
import { actionCreators } from "./redux/IntroductoryOfferSagas";
import LoadingAnimation from "../../../../components/loadingAnimation/loadingAnimation";
import IntroductoryOfferChart from "./smartComponents/IntroductoryOfferChart";
import TimePeriod from "./smartComponents/TimePeriod";
import DatePicker from "./smartComponents/DatePicker";
import { UpdateButtons } from "./smartComponents/UpdateButtons";
import CustomDateRanges from "./smartComponents/CustomDateRanges";

const OffersConvertedModule = (props) => {
  const dispatch = useDispatch();

  const isLoading = useSelector((state) => state.introductoryOffer.isLoading);
  const initialRequest = useSelector((state) => state.introductoryOffer.initialRequest);
  const updatesLoading = useSelector((state) => state.introductoryOffer.updatesLoading);

  useEffect(() => {
    !initialRequest && dispatch(actionCreators.fetchCurrentUser(props));
  }, []);

  const content = () => {
    return (
      <div>
        <div id="override-edit-selection-bar" className="edit-selections-bar">
          <div className="top-filter">
            <div></div>
            <div className="top-filter__right">
              <div className="select-box-no-width">
                <p>Period Time</p>
                <TimePeriod />
              </div>
              <div className="select-box-no-width date-range-select-box">
                <p>Date Range</p>
                <CustomDateRanges />
              </div>
              <div className="date-select-box select-box-no-width monthly">
                <p>Date</p>
                <DatePicker />
              </div>
              <UpdateButtons />
            </div>
          </div>
        </div>
        <div data-testid="charts-container" className="chart-root">
          {updatesLoading ? (
            <LoadingAnimation text="Updating data..." />
          ) : (
            <IntroductoryOfferChart />
          )}
        </div>
      </div>
    );
  };

  return (
    <div id="module-date-filters">
      <SectionToggle
        autoHeight
        height={690}
        title="Introductory Offer Retention"
        isLoading={isLoading}
        content={content()}
      />
    </div>
  );
};

OffersConvertedModule.propTypes = {
  params: PropTypes.object
};

export default React.memo(OffersConvertedModule);
